// extracted by mini-css-extract-plugin
export default {"root":"AVnKY","active":"O3NAK","closeBtn":"AtUdC"};